import { useApplicationContext } from '../utils/applicationContext';

export const useRepliesEnabled = (): boolean => {
  const { config } = useApplicationContext();

  return Boolean(config.get<boolean>('chats.replies.Enabled'));
};
